import API from "../config/api";
import { AwsImageUploadResponseType } from "../shared/types/types";

const getAuthHeaders = (): Record<string, string> => {
  const sessionData = JSON.parse(sessionStorage.getItem("sessionData") || "{}");
  const token = sessionData?.token;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
const GET = async (url: any, params?: any) => {
  return new Promise(async (resolve, reject) => {
    const queryParams = new URLSearchParams(params).toString();
    let apiurl = API.BASE_URL + url;
    if (params != null && queryParams) {
      apiurl = API.BASE_URL + url + "?" + queryParams;
    }
    fetch(apiurl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
    })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const POST = async (url: any, body: any) => {
  return new Promise(async (resolve, reject) => {
    fetch(API.BASE_URL + url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const PUT = async (url: any, body: any) => {
  return new Promise(async (resolve, reject) => {
    fetch(API.BASE_URL + url, {
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const DELETE = async (url: any) => {
  return new Promise(async (resolve, reject) => {
    fetch(API.BASE_URL + url, {
      method: "delete",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
    })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const COMPRESS_IMAGE = async (file: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const response = await fetch(
          `${API.BASE_URL}${API.FILE_COMPRESS_UPLOAD}`,
          {
            method: "POST",
            headers: {
              ...getAuthHeaders(),
            },
            body: formData,
          }
        );
        if (response.ok) {
          const jsonResponse: AwsImageUploadResponseType =
            await response.json();
          const obj = {
            ...jsonResponse,
            url: jsonResponse.Location,
            status: true,
          };
          resolve(obj);
        } else {
          let obj = {
            status: false,
            url: null,
          };
          resolve(obj);
        }
      } else {
        resolve("no file selected");
      }
    } catch (err) {
      resolve(err);
    }
  });
}

const UPLOAD_FILE = async (file: File) => {
  return new Promise(async (resolve) => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const response = await fetch(`${API.BASE_URL}${API.FILE_UPLOAD}`, {
          method: "POST",
          headers: {
            ...getAuthHeaders(),
          },
          body: formData,
        });
        if (response.ok) {
          const json = await response.json();
          // Expecting S3 upload response with Location
          resolve({
            ...json,
            url: json.Location,
            status: true,
          });
        } else {
          resolve({ status: false, url: null });
        }
      } else {
        resolve("no file selected");
      }
    } catch (err) {
      resolve({ status: false, url: null, error: err });
    }
  });
};

export { GET, POST, PUT, DELETE, COMPRESS_IMAGE, UPLOAD_FILE };
